import { __decorate, __metadata } from 'tslib';
import { EventEmitter, ViewChild, ElementRef, Input, Output, Component, NgModule } from '@angular/core';
import { UiBsTranslateService, UiBsTranslateModule } from '@wlp/ui-bs-translate';
import { Router, RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';

let UiCAsideMenuLeftComponent = class UiCAsideMenuLeftComponent {
    constructor(router, translate) {
        this.router = router;
        this.translate = translate;
        this.version = '0.0.0';
        this.route = new EventEmitter();
        this.buttonActive = -1;
        this.buttonActivesub = -1;
        this.isUp = false;
    }
    ngAfterViewInit() {
    }
    ngOnInit() {
    }
    // abre o menu principal
    openMenu() {
        const menu = this.main.nativeElement;
        menu.classList.toggle('opened');
        if (!menu.classList.contains('opened')) {
            this.closeAll();
        }
    }
    // metodo para abertura do submenu
    openSubMenu(e, option) {
        e.preventDefault();
        const el = e.currentTarget;
        const parent = el.parentNode;
        const ul = parent.querySelector('ul');
        // fecha todos os submenus abertos
        this.closeAll(ul, () => {
            el.classList.toggle('enabled');
            ul.classList.toggle('enabled');
            this.changeIconSubMenu(el, ul, option);
        });
    }
    // deve fechar todos os submenus
    closeAll(element, callback) {
        const parent = this.parent.nativeElement;
        parent.querySelectorAll('.sub-menu').forEach((el) => {
            if (el !== element) {
                const opt = el.parentNode;
                opt.querySelector('a').classList.remove('enabled');
                el.classList.remove('enabled');
                this.changeIconSubMenu(opt, el);
            }
        });
        this.options.forEach((el) => {
            el.open = false;
        });
        // chama o callback
        if (callback !== undefined) {
            callback();
        }
    }
    // modifica o icone do link para abertura do submenu
    changeIconSubMenu(el, ul, option) {
        const icon = el.querySelector('ion-icon.icon-display-menu');
        if (ul.classList.contains('enabled')) {
            icon.name = 'chevron-down-outline';
        }
        else {
            icon.name = 'chevron-forward-outline';
        }
        if (option) {
            this.options.forEach((el) => {
                el.open = false;
                if (option != null && option.label == el.label && ul.classList.contains('enabled')) {
                    el.open = true;
                }
            });
        }
    }
    checkUrlType(url) {
        let flag = false;
        if (typeof url === 'string') {
            flag = true;
        }
        return flag;
    }
    goTo(url) {
        if (url.includes('http:') || url.includes('https:')) {
            window.open(url, '_blank');
        }
        else {
            return this.router.navigate([url]);
        }
    }
    active(i) {
        this.buttonActive = i;
        this.buttonActivesub = -1;
    }
    activeSub(j) {
        this.buttonActivesub = j;
        this.buttonActive = -1;
    }
};
__decorate([
    ViewChild('parentElement', { static: true }),
    __metadata("design:type", ElementRef)
], UiCAsideMenuLeftComponent.prototype, "parent", void 0);
__decorate([
    ViewChild('mainMenu', { static: true }),
    __metadata("design:type", ElementRef)
], UiCAsideMenuLeftComponent.prototype, "main", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], UiCAsideMenuLeftComponent.prototype, "logoMenu", void 0);
__decorate([
    Input(),
    __metadata("design:type", Array)
], UiCAsideMenuLeftComponent.prototype, "options", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], UiCAsideMenuLeftComponent.prototype, "version", void 0);
__decorate([
    Output(),
    __metadata("design:type", Object)
], UiCAsideMenuLeftComponent.prototype, "route", void 0);
UiCAsideMenuLeftComponent = __decorate([
    Component({
        selector: 'ui-c-aside-menu-left',
        template: "<div (mouseenter)=\"openMenu()\" (mouseleave)=\"openMenu()\" id=\"menu-aside\" #mainMenu>\n  <div>\n    <nav>\n      <ul>\n        <li id=\"show-menu-btn\">\n          <a class=\"mb-0\" (click)=\"$event.preventDefault()\">\n            <img id=\"menu-brand\" [src]=\"logoMenu\" alt=\"\" />\n            <ion-icon class=\"icon\" name=\"chevron-forward-outline\"></ion-icon>\n          </a>\n        </li>\n      </ul>\n    </nav>\n    <nav id=\"nav-lateral\">\n      <ul #parentElement>\n        <!-- caminha entre o array de opcoes do menu -->\n        <!--  <ng-container>\n           <li>\n             <a (click)=\"order()\">\n               <span> Ordenar </span>\n               <ion-icon [class.hide]=\"!isUp\" name=\"chevron-down-outline\"></ion-icon>\n               <ion-icon [class.hide]=\"isUp\" name=\"chevron-up-outline\"></ion-icon>\n             </a>\n           </li>\n         </ng-container> -->\n        <ng-container *ngFor=\"let option of options; let i = index\">\n          <!-- se a opcao for unica (sem sub menu) -->\n          <ng-container *ngIf=\"checkUrlType(option.url)\">\n            <li>\n              <!-- <a *ngIf=\"!option.icon.includes('assets')\" [routerLink]=\"option.url\"> -->\n              <a (click)=\"active(i); goTo(option.url)\" [class.active]= \"buttonActive === i\">\n                <ion-icon *ngIf=\"!option.icon.includes('assets') && !option?.icon.includes('fas')\"  class=\"icon\" [name]=\"option.icon\"></ion-icon>\n                <ion-icon *ngIf=\"option.icon.includes('assets') && !option?.icon.includes('fas')\"  class=\"icon\" [src]=\"option.icon\"></ion-icon>\n                <i *ngIf=\"option?.icon && option?.icon.includes('fas')\" class=\"icon font-size-25 pb-2 {{option?.icon}}\"></i>\n                <span> {{ option.label | wlpTranslate}} </span>\n              </a>\n            </li>\n          </ng-container>\n\n          <ng-container *ngIf=\"!checkUrlType(option.url)\">\n            <li>\n              <a class=\"submenu-holder\" (click)=\"active(i); openSubMenu($event, option)\" [class.active]= \"buttonActive === i\">\n                <ion-icon *ngIf=\"!option.icon.includes('assets') && !option?.icon.includes('fas')\" class=\"icon\" [name]=\"option.icon\"></ion-icon>\n                <ion-icon *ngIf=\"option.icon.includes('assets') && !option?.icon.includes('fas')\" class=\"icon\" [src]=\"option.icon\"></ion-icon>\n                <i *ngIf=\"option?.icon && option?.icon.includes('fas')\" class=\"icon font-size-25 pb-2 {{option?.icon}}\"></i>\n                <span> {{ option.label | wlpTranslate}} </span>\n                <ion-icon [class.hide]=\"true\" class=\"icon-display-menu\" name=\"chevron-forward-outline\"></ion-icon>\n                <ion-icon [class.hide]=\"option.open\" [name]=\"'chevron-forward-outline'\"></ion-icon>\n                <ion-icon [class.hide]=\"!option.open\" [name]=\"'chevron-down-outline'\"></ion-icon>\n              </a>\n              <ul class=\"sub-menu disabled\">\n                <li *ngFor=\"let sub of option.url; let j = index\">\n                  <!-- <a [routerLink]=\"sub.url\"> -->\n                  <a (click)=\" activeSub(j); goTo(sub.url)\" [class.active]= \"buttonActivesub === j\" >\n                    <ion-icon class=\"icon submenu-i\" name=\"ellipse\"></ion-icon> {{ sub.label | wlpTranslate}}\n                  </a>\n                </li>\n              </ul>\n            </li>\n          </ng-container>\n        </ng-container>\n\n      </ul>\n    </nav>\n  </div>\n\n  <ion-grid class=\"footer-aside-menu-left\">\n    <ion-row class=\"ion-justify-content-center\">\n      <ion-col>\n        <div class=\"font-family-bold\" [innerHTML]=\"'v.' + version\"></div>\n      </ion-col>\n    </ion-row>\n  </ion-grid>\n</div>\n",
        styles: [""]
    }),
    __metadata("design:paramtypes", [Router,
        UiBsTranslateService])
], UiCAsideMenuLeftComponent);

let UiCAsideMenuLeftModule = class UiCAsideMenuLeftModule {
};
UiCAsideMenuLeftModule = __decorate([
    NgModule({
        declarations: [UiCAsideMenuLeftComponent],
        imports: [
            CommonModule,
            IonicModule,
            RouterModule,
            UiBsTranslateModule
        ],
        exports: [UiCAsideMenuLeftComponent]
    })
], UiCAsideMenuLeftModule);

export { UiCAsideMenuLeftComponent, UiCAsideMenuLeftModule };
//# sourceMappingURL=wlp-ui-c-aside-menu-left.js.map
